import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import AdminDashboard from './components/AdminDashboard';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Management from './pages/Management';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './pages/AdminLogin';
import DashboardHome from './pages/admin/DashboardHome';
import PagesManagement from './pages/admin/PagesManagement';
import TeamManagement from './pages/admin/TeamManagement';
import CompanyInfo from './pages/admin/CompanyInfo';
import MessagesInbox from './pages/admin/MessagesInbox';

function App() {
  // Hide loading screen when React is ready
  useEffect(() => {
    const loadingScreen = document.getElementById('loading-screen');
    if (loadingScreen) {
      // Small delay to ensure smooth transition
      setTimeout(() => {
        loadingScreen.classList.add('hidden');
        setTimeout(() => {
          loadingScreen.style.display = 'none';
        }, 300);
      }, 100);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <BackToTop />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <Layout>
            <Home />
          </Layout>
        } />
        <Route path="/about" element={
          <Layout>
            <About />
          </Layout>
        } />
        <Route path="/services" element={
          <Layout>
            <Services />
          </Layout>
        } />
        <Route path="/management" element={
          <Layout>
            <Management />
          </Layout>
        } />
        <Route path="/contact" element={
          <Layout>
            <Contact />
          </Layout>
        } />

        {/* Admin Routes */}
        <Route path="/AfAdmin" element={<AdminLogin />} />
        <Route path="/AfAdmin/dashboard" element={
          <AdminDashboard>
            <DashboardHome />
          </AdminDashboard>
        } />
        <Route path="/AfAdmin/pages" element={
          <AdminDashboard>
            <PagesManagement />
          </AdminDashboard>
        } />
        <Route path="/AfAdmin/team" element={
          <AdminDashboard>
            <TeamManagement />
          </AdminDashboard>
        } />
        <Route path="/AfAdmin/company" element={
          <AdminDashboard>
            <CompanyInfo />
          </AdminDashboard>
        } />
        <Route path="/AfAdmin/messages" element={
          <AdminDashboard>
            <MessagesInbox />
          </AdminDashboard>
        } />
        <Route path="/AfAdmin/gallery" element={
          <AdminDashboard>
            <div className="text-center py-12">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Gallery Module</h2>
              <p className="text-gray-600">Image gallery management coming soon.</p>
            </div>
          </AdminDashboard>
        } />
      </Routes>
    </Router>
  );
}

export default App;
